import { Button, Heading, ModalBody, ModalFooter, ModalHeader, Text, VStack } from '@chakra-ui/react';
import { Trans, useTranslation } from 'react-i18next';
import { SubmitFormBtn } from '../Buttons/SubmitFormBtn';
import { BaseModal } from './BaseModal';
import { CustomNavLink } from '../Links/CustomNavLink';
import { ROUTERS } from '../../data';

interface IMemberConfirmDeleting {
  isOpen: boolean;
  onClose: VoidFunction;
  onConfirm: VoidFunction;
  useName?: string;
  memberId: string | number;
}

export const MemberConfirmDeleting = (props: IMemberConfirmDeleting) => {
  const { t } = useTranslation();
  const { useName, isOpen, onClose, onConfirm, memberId } = props;

  return (
    <BaseModal isOpen={isOpen} onClose={onClose}>
      <>
        <ModalHeader lineHeight='130%'>{t('modal.deleting.member.caption', { userName: useName })}</ModalHeader>

        <ModalBody>
          <Heading fontSize='md'>{t('modal.deleting.member.text.1')}</Heading>

          <Text mt={6} px={2} lineHeight='150%'>
            <Trans
              i18nKey={'modal.deleting.member.text.2'}
              components={[
                <CustomNavLink to={ROUTERS.USER.MEMBER_TO_USER} state={{ memberId }} variant='underlinePrimary'>
                  'transfer'
                </CustomNavLink>,
              ]}
            />
          </Text>
        </ModalBody>

        <ModalFooter>
          <VStack spacing={4}>
            <SubmitFormBtn size='lg' minH={14} py={2} onClick={onConfirm}>
              {t('confirm.deleting')}
            </SubmitFormBtn>
            <Button variant='linkUnderlinePrimary' size='sm' onClick={onClose}>
              {t('cancel')}
            </Button>
          </VStack>
        </ModalFooter>
      </>
    </BaseModal>
  );
};
